import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

// 화면 상태를 주소(URL)의 쿼리 파라미터에 둔다. 주소를 그대로 복사해 보내면 받는 사람도 같은 화면을 연다
// (권한이 없으면 못 본다). 공유 단추는 따로 없다.
//
//   const [url, setUrl] = useUrlState();
//   url.get('company')                       // 읽기
//   setUrl({ company: id, employee: null })  // 여러 개를 한 번에 바꾼다(null·'' 이면 지운다)
//   setUrl({ q: text }, { replace: true })   // 입력 중처럼 뒤로 가기 기록을 쌓지 않을 때
//
// 같은 이벤트 안에서 setUrl 을 두 번 부르면 앞의 것이 덮이므로, 바꿀 값은 한 번에 넘긴다.
export function useUrlState() {
  const [params, setParams] = useSearchParams();
  const set = useCallback((changes, { replace = false } = {}) => {
    setParams((prev) => {
      const next = new URLSearchParams(prev);
      Object.entries(changes).forEach(([key, value]) => {
        if (value === null || value === undefined || value === '') next.delete(key);
        else next.set(key, String(value));
      });
      return next;
    }, { replace });
  }, [setParams]);
  return [params, set];
}

export default useUrlState;
